import { render, staticRenderFns } from "./FormServiceReview.vue?vue&type=template&id=535c6750&"
import script from "./FormServiceReview.vue?vue&type=script&lang=js&"
export * from "./FormServiceReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports